module.exports = __webpack_public_path__ + "assets/img/AdditionReward_tit.ad58665d.png";